'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errTxt = exports.MAX_BYTES = exports.setFileName = exports.getFileName = undefined;

var _join2 = require('lodash/fp/join');

var _join3 = _interopRequireDefault(_join2);

var _at2 = require('lodash/fp/at');

var _at3 = _interopRequireDefault(_at2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

exports.loadSha = loadSha;
exports.loadImageDataUrl = loadImageDataUrl;
exports.loadImage = loadImage;

var _simpleSha = require('simple-sha1');

var _simpleSha2 = _interopRequireDefault(_simpleSha);

var _capeLodash = require('cape-lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window */

var getFileName = exports.getFileName = (0, _flow3.default)((0, _at3.default)(['contentSha1', 'ext']), (0, _join3.default)('.'));
var setFileName = exports.setFileName = (0, _capeLodash.setField)('fileName', getFileName);
var MAX_BYTES = exports.MAX_BYTES = 4100069;
var errTxt = exports.errTxt = 'Invalid image file. The file is corrupt or has the wrong filename extension.';

// export const getCollectionId = propertyOf({ image: 'ImageObject' })

// Write values to contentSha1 and fileName fields.
function loadSha(file) {
  var reader = new window.FileReader();
  return new Promise(function (resolve, reject) {
    reader.onloadend = function () {
      return (0, _simpleSha2.default)(reader.result, (0, _flow3.default)((0, _capeLodash.setKey)('contentSha1', file), setFileName, resolve));
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file.file);
  });
}

function loadImageDataUrl(file) {
  return new Promise(function (onSuccess, onError) {
    if (file.size > MAX_BYTES) return onSuccess();
    var reader = new window.FileReader();
    reader.onloadend = function () {
      var img = new window.Image();
      img.onerror = function () {
        return onError(errTxt);
      };
      img.onload = function () {
        onSuccess({
          dataUrl: reader.result, // Include fileData base64 thing.
          height: { unitCode: 'E37', value: img.height, unitText: 'pixel' },
          width: { unitCode: 'E37', value: img.width, unitText: 'pixel' }
        });
      };
      img.src = reader.result;
    };
    return reader.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise(function (onSuccess, onError) {
    var img = new window.Image();
    img.onerror = onError;
    img.onload = onSuccess;
    img.src = src;
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/FileUpload/windowFileUtils.js
// module id = 306
// module chunks = 0